import type { Chat } from '@/features/studio-renew/types'

/** 편집 의도용 예약 경로다. 이 값을 서버 리소스 ID로 전송하지 않는다. */
export const WORK_DRAFT_ID = 'new'

export function emptyWork(
  characterIds: string[] = [],
  worldId: string | null = null
): Omit<Chat, 'id' | 'updatedAt'> {
  return {
    name: '',
    characterIds,
    lead: characterIds[0] ?? null,
    maxSpeakers: 1,
    worldId,
    starts: [],
    playGuide: '',
    statusId: null,
    places: [],
    situation: '',
    narrator: '',
    difficulty: 'normal',
    pace: 'natural',
    albumOn: false,
    albumPlaces: [],
    commandIds: [],
    officialCommands: [],
    description: '',
    genre: '',
    tags: [],
    covers: [],
    target: '여성향',
    audience: null,
    audienceLocked: false,
    visibility: 'private',
    consent: false,
    commentsOn: true,
    review: 'draft',
  }
}

const filled = (value?: string | null) => !!value?.trim()

/** ID·시각·빈 편집 행·기본 설정은 값으로 치지 않는다. 사용자 입력/연결/설정 변경만 저장을 시작한다. */
export function hasWorkValues(work: Chat): boolean {
  return !!(
    filled(work.name) ||
    filled(work.description) ||
    filled(work.cover) ||
    filled(work.introGif) ||
    filled(work.titleImage) ||
    work.characterIds.length ||
    work.worldId ||
    work.statusId ||
    work.commandIds.length ||
    work.officialCommands.length ||
    work.places?.some(filled) ||
    filled(work.playGuide) ||
    filled(work.situation) ||
    filled(work.narrator) ||
    filled(work.genre) ||
    work.tags.some(filled) ||
    work.starts.some(
      (start) =>
        filled(start.name) ||
        filled(start.place) ||
        filled(start.intro.context) ||
        start.intro.lines.some(
          (line) => filled(line.text) || filled(line.image)
        ) ||
        start.suggestions.some(filled)
    ) ||
    work.albumPlaces.some(
      (place) =>
        filled(place.name) ||
        place.scenes.some((scene) => filled(scene.image) || filled(scene.title))
    ) ||
    work.audience != null ||
    work.consent ||
    work.commentsOn === false ||
    work.visibility !== 'private' ||
    work.target !== '여성향' ||
    work.maxSpeakers !== 1 ||
    work.albumOn ||
    (work.difficulty != null && work.difficulty !== 'normal') ||
    (work.pace != null && work.pace !== 'natural')
  )
}
